import { render, staticRenderFns } from "./IndexFooter.vue?vue&type=template&id=4dbc9e94&scoped=true"
import script from "./IndexFooter.vue?vue&type=script&lang=js"
export * from "./IndexFooter.vue?vue&type=script&lang=js"
import style0 from "./IndexFooter.vue?vue&type=style&index=0&id=4dbc9e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbc9e94",
  null
  
)

export default component.exports